import { render, staticRenderFns } from "./TextBanner.vue?vue&type=template&id=bbeb6e98&"
import script from "./TextBanner.vue?vue&type=script&lang=js&"
export * from "./TextBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbeb6e98')) {
      api.createRecord('bbeb6e98', component.options)
    } else {
      api.reload('bbeb6e98', component.options)
    }
    module.hot.accept("./TextBanner.vue?vue&type=template&id=bbeb6e98&", function () {
      api.rerender('bbeb6e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/components/TextBanner.vue"
export default component.exports